import React from 'react';
import { Spin } from 'antd';
import './style.css'; // Import the CSS for full-screen styling
import { LoadingOutlined } from '@ant-design/icons';

const FullPageLoader = () => {
  return (
    <div className="full-screen-loader">
      <Spin indicator={<LoadingOutlined className='text-[#fab700]' spin />} size="large" />
    </div>
  );
};

export default FullPageLoader;
